/* eslint-disable camelcase */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { routerRedux, Switch, Route, withRouter } from 'dva/router';
import { isEmpty, isFunction, throttle } from 'lodash';

import { getConfig } from 'hzero-boot';
import { Modal, Spin } from 'hzero-ui';
import ModalContainer, { registerContainer } from 'components/Modal/ModalContainer';
import { ModalContainer as C7nModalContainer } from 'choerodon-ui/pro';
import Authorized from 'components/Authorized/WrapAuthorized';
import PermissionProvider from 'components/Permission/PermissionProvider';
// import { openTab } from 'hzero-front/lib/utils/menuTab';

import LocalProviderAsync from 'utils/intl/LocaleProviderAsync';

import { dynamicWrapper } from 'utils/router';
import { inject } from 'what-di';
import DefaultContainer from 'utils/iocUtils/DefaultContainer';
import { initIoc } from 'utils/iocUtils';
import { UedProvider } from 'utils/iocUtils/UedProvider';
import formatterCollections from 'utils/intl/formatterCollections';
import intl from 'utils/intl';
// import { getAccessToken, getCurrentOrganizationId, getCurrentRole } from 'utils/utils';
import { getAccessToken, getCurrentOrganizationId, getCurrentUser } from 'utils/utils';
// import { LOGIN_URL } from 'utils/config';
import request from 'utils/request';
import { SRM_PLATFORM, SRM_MALL_HOST, SRM_MALL } from '_utils/config';
import { API_HOST } from 'utils/config';
import { getDvaApp } from 'hzero-front/lib/utils/iocUtils';
import ResetPassWord from './ResetPassWord';

// 初始化ioc容器
initIoc(); // Inversion of Control 控制反转
// DI 依赖注入（dependency injection）

const WithRouterC7nModalContainer = withRouter(C7nModalContainer);
const { ConnectedRouter } = routerRedux;
const { DefaultAuthorizedRoute, PubAuthorizedRoute } = Authorized;
// const allowProblem = ['administrator', 'srm_sysdev', 'experts', 'zpr_srm_src_ku', 'zpr_srm_it_engineer', 'zpr_srm_it_authority'];

// 高德地图安全密钥、key配置
const { host } = window.location;
const isProduction = host.includes('srm2');
window._AMapSecurityConfig = {
  securityJsCode:
    isProduction
      ? "d7827a33c37cc5b994af4e0a1ceb956e"
      : "63d5544b9a4f2d83433df14f1de0dcdf",
  AMapKey:
    isProduction
      ? "4c6d0e66e68ad788f17e52134e3a4f7f"
      : "eff10aa45f03eb23b46b53c14cddf767",
};

@formatterCollections({
  code: ['srm.common', 'hzeo.common', 'srm.oauth'],
})
class LeadLink extends React.Component {
  state = {
    mall_host: undefined,
    mallLink: false,
    isSupplier: false,
  };

  /**
   * 查询二级地址商城域名配置
   */
  queryMallHost = () => {
    const srmUrl = window.location.origin;
    return request(`${SRM_MALL}/v1/mall-page-configs/mall-config`, {
      method: 'GET',
      query: { srmUrl },
    });
  };

  /**
   * 查询用户租户信息配置
   */
  queryTenants = () => {
    const { dvaApp } = this.props;
    return dvaApp._store.dispatch({
      type: 'user/fetchTenantList',
    });
  };

  queryLinkConfig = () => {
    const url = window.location.host;
    return request(`${SRM_PLATFORM}/v1/portal-assigns-cache`, {
      method: 'GET',
      query: { url },
    });
  };

  // 查询是否是供应商
  queryCharacter = () => {
    return request(`${SRM_PLATFORM}/v1/${getCurrentOrganizationId()}/receipt-applys/auth`, {
      method: 'GET',
      responseType: 'text',
    });
  }

  // 注册手机号前缀
  registerPhone = async () => {
    const initInfo = getConfig('initPhone');
    if (isFunction(initInfo)) {
      initInfo();
    }
  };

  async componentDidMount() {
    // if (getCurrentTenant() && getCurrentTenant().tenantNum === 'SRM-PORSCHE') {
    //   modifyVars(
    //     // 更换主题颜色要这么写
    //     {
    //       '@Porsche-Font-Family': 'PorscheFont',
    //     }
    //   );
    // }
    this.registerPhone();
    this.queryMallHost().then(res => {
      if (!isEmpty(res)) {
        this.setState({
          mall_host: res.webUrl,
        });
      }
    });
    this.queryLinkConfig().then(res => {
      if (!isEmpty(res) && !res.failed && res.navbar) {
        const configs = JSON.parse(res.navbar);
        if (configs.length > 0) {
          const jsonConfig = configs.map(c => JSON.parse(c));
          this.setState({
            mallLink: jsonConfig.find(r => r.content === 'mallLink').description || true,
            // financialLink: jsonConfig.find(r => r.content === 'financialLink').description || true,
          });
        }
      } else {
        this.setState({
          mallLink: true,
          // financialLink: true,
        });
      }
    });

    this.queryCharacter().then(res => {
      if (!isEmpty(res)) {
        this.setState({
          isSupplier: res === 'SUPPLIER',
        });
      }
    });

    await this.queryTenants();
  }

  handleToFeedback = () => {
    this.props.dvaApp._store.dispatch(routerRedux.push({ pathname: `/sslm/feedback` }));
    // openTab({
    //   key: '/sslm/feedback',
    //   path: '/sslm/feedback',
    //   title: intl.get('srm.common.view.title.feedback').d('问题反馈'),
    //   closable: true,
    //   type: 'menu',
    // });
  }


  render() {
    const { mall_host, mallLink, isSupplier } = this.state;
    const accessToken = getAccessToken();
    // const roleCode = getCurrentRole().code;
    return (
      <React.Fragment>
        {!!+mallLink && !isSupplier && (
          <a
            style={{ color: '#ccc', fontSize: '14px', marginLeft: '20px' }}
            target="_blank"
            rel="noopener noreferrer"
            href={`${mall_host || SRM_MALL_HOST}#access_token=${accessToken}`}
          >
            <span>{intl.get('srm.common.view.title.enterpriseMall').d('企业商城')}</span>
          </a>
        )}
        <a
          style={{ color: '#ccc', fontSize: '14px', marginLeft: '20px' }}
          target="_blank"
          rel="noopener noreferrer"
          href={`${API_HOST}/oauth/public/stander/resource_download.html?hasLogin=Y&access_token=${accessToken}`}
        >
          <span>{intl.get('srm.common.view.title.operation').d('操作手册')}</span>
        </a>
        {/* {(isSupplier || (!isSupplier && allowProblem.includes(roleCode))) && (
        <a
          style={{ color: '#ccc', fontSize: '14px', marginLeft: '20px' }}
          onClick={this.handleToFeedback}
        >
          <span>{intl.get('srm.common.view.title.feedback').d('问题反馈')}</span>
        </a>
        )} */}
        <a
          style={{ color: '#ccc', fontSize: '14px', marginLeft: '20px' }}
          onClick={this.handleToFeedback}
        >
          <span>{intl.get('srm.common.view.title.feedback').d('问题反馈')}</span>
        </a>
        {/* {!!+financialLink && (
          <a
            style={{color: '#ccc', fontSize: '14px', marginLeft: '20px' }}
            target="_blank"
            rel="noopener noreferrer"
            href="https://hjl.hscf.com/mkt/index"
          >
            <span>{intl.get('srm.common.view.title.financialMarket').d('金融超市')}</span>
          </a>
        )}
        <a
          style={{color: '#ccc', fontSize: '14px', marginLeft: '20px' }}
          target="_blank"
          rel="noopener noreferrer"
          href={LOGIN_URL}
        >
          <span>{intl.get('srm.common.view.title.SRMPortal').d('SRM门户')}</span>
        </a> */}
        {/* 此功能暂时先注释，后续再考虑上 */}
        {/* <a style={{color: '#ccc', fontSize: '14px', marginLeft: '20px' }} target="_self" href="ATLPortal:System:CHANDAO-4422827">
          <Icon type="question-circle-o" />
          {' '}{intl.get('srm.common.view.title.questionFeedback').d('问题反馈')}
        </a> */}
        <NoticeModal dvaApp={this.props.dvaApp} />
      </React.Fragment>
    );
  }
}

function NoticeModal(props) {

  const [data, setData] = useState([]);
  const [totalElements, setTotal] = useState(0);
  const [{ loading, isFinished }, setLoad] = useState({ loading: false, isFinished: false });
  const pagination = useRef({
    currentPage: 0,
    totalElements: 0,
    size: 20,
  });

  const queryNotice = useCallback(() => {
    const searchPage = {
      page: pagination.current.currentPage,
      size: pagination.current.size,
    };
    if (pagination.current.currentPage > Math.floor(pagination.current.totalElements / searchPage.size)) {
      return false;
    }

    setLoad({
      loading: true,
      isFinished: false,
    });

    queryNoticeService(searchPage).then(res => {
      if (res && res.content && res.content.length > 0) {
        setData((preData) => preData.concat(res.content));
        if ((typeof res.number === 'number' ? res.number : res.start) + 1 > Math.floor(res.totalElements / res.size)) {
          setLoad({
            isFinished: true,
            loading: false,
          });
        } else {
          setLoad({
            isFinished: false,
            loading: false,
          });
        }
        setTotal(res.totalElements);
        pagination.current = {
          currentPage: (typeof res.number === 'number' ? res.number : res.start) + 1,
          totalElements: res.totalElements || 0,
          size: res.size || 20,
        };
      }
    }).catch(() => {
      setLoad({
        isFinished: false,
        loading: false,
      });
    });
  }, [queryNoticeService]);

  useEffect(() => {
    queryNotice();
  }, [queryNotice]);

  useEffect(() => {
    const scrollEvent = throttle((e) => {
      if (isFinished) {
        return false;
      }
      if (e.target.id === 'hzero-notice-content') {
        const scrollhight = e.target.scrollTop + e.target.clientHeight + 60;
        if (Math.ceil(scrollhight) >= e.target.scrollHeight) {
          queryNotice();
        }
      }
    }, 500);
    document.addEventListener('scroll', scrollEvent, true);
    return () => {
      document.removeEventListener('scroll', scrollEvent, true);
    };
  }, [queryNotice, isFinished]);

  const linkNoticeDetail = (record) => {
    const noticeIds = data.map(r => r.noticeId);
    props.dvaApp._store.dispatch(routerRedux.push({ pathname: `/hmsg/user-message/enter-announce-preview/${record.noticeId}`, state: noticeIds }));
    setData([]);
  };

  // 查询是否是供应商
  const queryNoticeService = useCallback(({ page = 0, size = 20 } = {}) => {
    return request(`${SRM_PLATFORM}/v1/${getCurrentOrganizationId()}/platform-notices-work`, {
      method: 'GET',
      query: {
        page,
        size,
        readFlag: 0,
        mustReadingFlag: 1,
        pageStatusCode: 'EXHIBITING',
      },
    });
  }, []);

  const cancelModal = () => {
    setData([]);
  };

  return (
    <Modal
      key='notice-modal'
      destroyOnClose
      width={468}
      className='root-notice-modal'
      onCancel={cancelModal}
      footer={isFinished && <p className='textAlign-left'>{intl.get('hzero.common.view.loadFinished').d('所有未读公告已加载完成')}</p>}
      visible={!!data.length}
    >
      {/* 为用户预留头部额外显示文字 */}
      {intl.get('hzero.common.modal.notice.header.allow') && <p className='hzero-notice-header'>{intl.get('hzero.common.modal.notice.header.allow')}</p>}
      <p className='hzero-notice-header'>{intl.get('hzero.common.modal.notice.noRead').d('尊敬的用户, 您有以下公告未阅读, 请及时查看')}</p>
      <Spin spinning={loading}>
        <div id='hzero-notice-content'>
          {data.map(item => (<p key={item.noticeId} onClick={() => linkNoticeDetail(item)}> {item.title} </p>))}
          <div className='notice-assist-space'>
            {loading && <Spin spinning>{intl.get('hzero.common.view.loading').d('加载中...')}</Spin>}
          </div>
        </div>
        <p style={{ textAlign: 'right', color: '#000' }}>{intl.get('hzero.common.notice.current.displayCount', { count: data.length }).d(`当前显示${data.length}条`)} / {intl.get('hzero.common.notice.count', { count: totalElements }).d(`共${totalElements}条`)}</p>
      </Spin>
    </Modal>
  );
}

function RouterConfig({ history, app }) {
  const [uedConfig, setUedConfig] = useState({
    Container: DefaultContainer,
  });

  const Layout = dynamicWrapper(app, ['user', 'login'], () =>
    import('hzero-front/lib/layouts/Layout')
  );
  const PubLayout = dynamicWrapper(app, ['user', 'login'], () =>
    import('hzero-front/lib/layouts/PubLayout')
  );

  // 免登陆无权限路由
  const PublicLayout = dynamicWrapper(app, [], () =>
    import('hzero-front/lib/layouts/PublicLayout')
  );
  // 免登陆权限路由
  const PrivateLayout = dynamicWrapper(app, [], () =>
    import('hzero-front/lib/layouts/PrivateLayout')
  );

  useEffect(() => {
    const ued = inject(UedProvider);
    ued.subscribe(({ Container = null }) => {
      setUedConfig({
        Container: Container || DefaultContainer,
      });
    });
  }, []);

  // 获取模块信息
  const getTreeIds = (tree, nodeId, config) => {
    const { children = 'children', id = 'id' } = config || {};
    const toFlatArray = (treeArr) => {
      return treeArr.reduce((t, _) => {
        const child = _[children];
        return [
          ...t,
          _,
          ...(child && child.length ? toFlatArray(child) : [])];
      }, []);
    };
    const getIds = flatArray => {
      let names = [];
      function getElement(arr, selectId) {
        return arr.find(_ => _[id] === selectId);
      }
      let child = getElement(flatArray, nodeId);
      while (child && child.parentId !== undefined) {
        names = [ child.title, ...names ];
        child = getElement(flatArray, child.parentId);
      }
      return names;
    };
    return getIds(toFlatArray(tree));
  };

  // 上传菜单信息
  const uploadMenuInfo = (data) => {
    return request(`${SRM_PLATFORM}/v1/${getCurrentOrganizationId()}/menu-logs`, {
      method: 'POST',
      body: data,
    });
  };

  let currentMenuId = '';

  // 获取参数
  const getUrlParam = (name) => {
    const reg = new RegExp(`(^|&)${ name }=([^&]*)(&|$)`); // 构造一个含有目标参数的正则表达式对象
    const r = window.location.search.substr(1).match(reg); // 匹配目标参数
    if (r != null) return unescape(r[2]); return null; // 返回参数值
  };

  return (
    <uedConfig.Container defaultTheme="theme2">
      <LocalProviderAsync>
        <PermissionProvider>
          <ConnectedRouter history={history}>
            <>
              <ModalContainer ref={registerContainer} />
              <WithRouterC7nModalContainer />
              <Switch>
                <Route path="/private" render={props => <PrivateLayout {...props} />} />
                <Route path="/public" render={props => <PublicLayout {...props} />} />
                <PubAuthorizedRoute path="/pub" render={props => <PubLayout {...props} />} />
                <DefaultAuthorizedRoute
                  path="/"
                  render={props => {
                    const externalLink = sessionStorage.getItem('externalLink');
                    if (externalLink === 'true') {
                      const style = document.createElement('style');
                      style.id = 'externalLinkStyle';
                      style.appendChild(document.createTextNode(`
                        .hzero-common-layout-header {
                          display: none !important;
                        }
                        .hzero-common-layout-aside {
                          display: none !important;
                        }
                        .hzero-common-layout-content > .ant-tabs > .ant-tabs-bar {
                          display: none !important;
                        }
                        .hzero-common-layout-content-wrap .hzero-common-layout-content > .ant-tabs.ant-tabs-top > .ant-tabs-content {
                          height: 99vh;
                        }
                      `));
                      document.head.appendChild(style);
                      const { search } = window.location;
                      const hasExternalLink = getUrlParam('externalLink');
                      if (search && !hasExternalLink) {
                        window.history.replaceState("", "", `${window.location.href}&externalLink=true`);
                      } else if (!hasExternalLink) {
                        window.history.replaceState("", "", `${window.location.href}?externalLink=true`);
                      }
                    }
                    const { global } = getDvaApp()._store.getState();
                    const { activeTabMenuId, activeTabKey, menu } = global;
                    if (activeTabMenuId && activeTabMenuId !== currentMenuId) {
                      const menuId = activeTabMenuId;
                      const menuArr = getTreeIds(menu, activeTabMenuId);
                      const menuName = menuArr.join('-');
                      const { loginName } = getCurrentUser();
                      const tenantId = getCurrentOrganizationId();
                      const params = {
                        menuId,
                        menuName,
                        createName: loginName,
                        tenantId,
                      };
                      uploadMenuInfo(params);
                    }
                    currentMenuId = activeTabKey === '/workplace' ? '' : activeTabMenuId;
                    return (
                      <>
                        <Layout
                          extraHeaderRight={[<LeadLink dvaApp={app} />]}
                          headerProps={{
                            toolbarProps: { extraHeaderRight: <LeadLink dvaApp={app} /> },
                          }}
                          {...props}
                        />
                        <ResetPassWord dvaApp={app} />
                      </>
                    );
                  }}
                />
              </Switch>
            </>
          </ConnectedRouter>
        </PermissionProvider>
      </LocalProviderAsync>
    </uedConfig.Container>
  );
}

export default RouterConfig;
